

















































































































































































































































































































































































































































































































import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetVoipQICaseReq,
  GetVoipQICaseListReq,
  SaveVoipQICaseReq,
  AudioMarkText,
  VoipQICaseData,
} from "@/pbjs/xcommon/collection_pb.js";
import {
  QualityReport,
  QualityObject,
  SimInfo,
} from "@/pbjs/xcommon/ticket_pb.js";
import {
  GetVoipQITicketListReq,
  GetTicketListReq,
  BatchAssignTicketReq,
  BatchRecycleTicketReq,
  BatchEntrustTicketReq,
  RollApplyTicketReq,
  ReduceTicketReq,
  GetTicketListParamReq,
  CloseTicketReq,
  Bool,
  GetAudioQualityRuleListReq,
  AudioQualityRuleData,
} from "@/pbjs/external/ticket/ticket_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";
import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "ApplicationReview", //"ManualUpgradeTicketDialogue",
  components: {
    Copywriting: () => import("./orderDeal/components/Copywriting.vue"),
    Qualityinspectionlabel: () =>
      import("./orderDeal/components/Qualityinspectionlabel.vue"),
  },
})
export default class ApplicationReview extends Vue {
  // @Prop() recotData!: any;
  // @Prop() sopeRow!:any;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 10;
  @Provide() private pagerCount: number = 0;
  @Provide() private itemId: any = "";
  @Provide() private callrecordid: any = "";
  @Provide() private audioPlayLoading: Boolean = false;
  @Provide() private disabled: Boolean = false;
  @Provide() private disabledSubmit: Boolean = false;
  @Provide() private MachineQuality: any = "";
  @Provide() private textareaText: any = "";
  @Provide() private selecterr: any = "";
  @Provide() private isfix: Boolean = true;
  @Provide() private voipqiresultmapMap: any = [];

  @Provide() private timelong: number = 0;
  @Provide() private audio: any = [];
  @Provide() private recotData: any = [];
  @Provide() private resultData: any = []; // 列表结果
  @Provide() private caseresultListData: any = [];
  @Provide() private caseresultListDataS: any = [];
  @Provide() private offsetX: any = [];
  @Provide() private aa: any = [];
  @Provide() private offsetY: number = 0;
  @Provide() private showDialogType: any = 0;
  @Provide() private ManualUpgradeTicketDialogueForm: any = {
    OverdueDay: "",
  };
  @Provide() private rules: any = {
    OverdueDay: [
      { required: true, message: "Pls enter a number value", trigger: "blur" },
    ],
  };
  // lee 手动升级操作的接口请求是否完成，布尔值
  @Provide() private inputValue: any = [];
  @Provide() private urgeusername: any = "";
  @Provide() private caseid: any = "";
  @Provide() private disableQ: boolean = false;
  @Provide() private isshowButton: boolean = false;
  @Provide() private isGetManualUpgradeTicketActionDone: boolean = false;
  @Provide() private Aging: any = "";
  @Provide() private status: any = "";
  @Provide() private selectTextId: any = "";
  @Provide() private selectText: any = "";
  @Provide() private humanscore: any = "";
  @Provide() private aiscore: any = "";
  @Provide() private cn: any = "";

  @Provide() private part: any = "";
  @Provide() private finalscoreList: any = "";
  @Provide() private sureAbandonindex: any = "";
  @Provide() private AudioMarkTextList: any = [];
  @Provide() private savecheckedRuleList: any = [];

  @Provide() private sliderValue: any = [100, 20, 48];
  @Provide() private calltextList: any = [{}];
  @Provide() private title: any = "";
  @Provide() private caseresult: any = "";
  @Provide() private audiorecordurl: any = "";
  @Provide() private calldirection: any = "";
  @Provide() private hangupcause: any = "";
  @Provide() private starttimestamp: any = "";
  @Provide() private dialinfo: any = {};
  @Provide() private isCheckednormal: boolean = false;
  @Provide() private timestart: any = "";
  @Provide() private timeend: any = "";
  @Provide() private Copywritingindex: any = "";
  @Provide() private positionwith: any = "";
  @Provide() private checkedRuleid: any = [];
  @Provide() private checkedRule: any = [];
  @Provide() private checkedNodes: any = [];
  @Provide() private humanqualityList: any = [];

  @Provide() private recotdingForm: any = {
    name: null,
    // normal:false,
    result: [{ label: "" }, { label: "" }, { label: "" }, { label: "" }],
    resultTxt: "",
  };
  @Provide() private RecotdinCheckList: any = [
    { label: "dashbordDy.normal" },
    { label: "dashbordDy.AbusiveCustomer" },
    { label: "dashbordDy.sop" },
    { label: "dashbordDy.CustomerPromises" },
  ];
  @Provide() private dynamicTags: any = [[], [], [], []];
  @Provide() private inputVisible: any = [
    { Label: 0, bool: false, list: [] },
    { Label: 1, bool: false, list: [] },
    { Label: 2, bool: false, list: [] },
    { Label: 3, bool: false, list: [] },
  ];
  private created(): void {
    this.itemId = this.$route.query.id;
    this.title = this.$route.query.title;
    // this.status = this.$route.query.status;
    this.callrecordid = this.$route.query.callrecordid;
    this.getVoipQICaseReq(this.itemId);
    this.getAudio(this.callrecordid);
    // 按钮宽度不同语言适配
    this.cn = localStorage.getItem("cn");
    if (this.cn == "id-ID") {
      this.positionwith = "440px";
    } else if (this.cn == "en-US") {
      this.positionwith = "240px";
    } else if (this.cn == "zh-CN") {
      this.positionwith = "155px";
    }
    // if (this.$route.query.status == this.$tc("performance.completed")) {
    //   this.disableQ = true;
    //   // this.isshowButton = false;
    // }
  }
  // formatTooltip(val) {
  //     return val / 100;
  //   }
  private mounted() {
    (document as any).body.onclick = (event: any) => {
      this.blur();
      event.stopImmediatePropagation();
    };
  }
  private focunsCon() {
  }
  private Copywriting(event: any, item: any, index: any) {
    const e = event || window.event;
    e.stopPropagation();
    this.part = "part" + item.sentence;
    this.timestart = item.timestart;
    this.timeend = item.timeend;
    this.Copywritingindex = index;
    this.showDialogType = 2;
  }
  private Qualityinspectionlabel(event: any, item: any) {
    const e = event || window.event;
    e.stopPropagation();
    this.showDialogType = 3;
    this.QualityRuleList();
  }
  private QualityRuleList() {
    let request: any = new GetAudioQualityRuleListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(0, 999));
    let requestAuto: any = new AudioQualityRuleData();
    requestAuto.setId();
    requestAuto.setRulename(); //(this.ruleForm.ruleName).toString()
    requestAuto.setRuletext();
    requestAuto.setScorepolicy();
    requestAuto.setScore();
    requestAuto.setUsername();
    requestAuto.setPointnum();
    requestAuto.setCtime();
    requestAuto.setStatus(1);
    request.setData(requestAuto);
    ticketClient.getAudioQualityRuleList(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getRoleListAPIFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private getRoleListAPIFuc(data: any) {
    this.caseresultListDataS = data.listList;
    // data.listList.map((item: any) => {
    //   if (item.status == 1) {
    //     this.caseresultListDataS.push(item);
    //   }
    // });
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.$emit("refreshTable", this.pageIndex, this.pageSize);
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.$emit("refreshTable", this.pageIndex, this.pageSize);
  }
  private hideManualUpgradeTicketDialogue(val: any) {
    this.showDialogType = val;
  }
  private savecheckedRule(val: any) {
    if (val) {
      //1.只有全部选中halfCheckedNodes没有和children有
      //2.只有一半选中有halfCheckedNodes和checkedNodes.children没有
      //3.全部选中一半选中都有halfCheckedNodes和checkedNodes.children有

      // this.checkedRuleid = (this.$refs
      //   .Qualityinspectionlabel as any).checkedRuleid;
      this.checkedRule = (this.$refs.Qualityinspectionlabel as any).checkedRule;
      this.checkedNodes = (this.$refs
        .Qualityinspectionlabel as any).checkedNodes;
      //判断是否有children
      let ifchildren: any = [];

      if (this.checkedNodes.length > 0) {
        this.checkedNodes.forEach((item: any) => {
          if (item.children) {
            ifchildren.push("true");
          }
        });
      }

      // this.checkedNodes.forEach((item: any) => {
      //只有全部选中
      if (this.checkedRule.length == 0 && ifchildren.length > 0) {
        let res: any = [];
        this.checkedNodes.forEach((item: any) => {
          if (item.children) {
            res.push(item);
          }
        });
        this.checkedRule = res;
      } else if (this.checkedRule.length > 0 && ifchildren.length == 0) {
        //只有一半选中
        let arr: any = [];
        this.checkedRule.forEach((item: any, index: any) => {
          arr = [];
          item.children.forEach((c: any, y: any) => {
            this.checkedNodes.forEach((o: any, m: any) => {
              if (o.$treeNodeId == c.$treeNodeId) {
                arr.push(o);
                //
              }
            });
          });
          item.children = arr; //选中的关键字
        });
      } else if (this.checkedRule.length > 0 && ifchildren.length > 0) {
        let arrAll: any = [];
        this.checkedNodes.forEach((item: any) => {
          if (item.children) {
            arrAll.push(item); //全部选择
          }
        });

        let arrHelf: any = []; //部分选择
        // arrHelf = this.checkedRule;
        this.checkedRule.forEach((item: any, index: any) => {
          arrHelf = [];
          item.children.forEach((c: any, y: any) => {
            this.checkedNodes.forEach((o: any, m: any) => {
              if (o.$treeNodeId == c.$treeNodeId) {
                arrHelf.push(o);
                //
              }
            });
          });
          item.children = arrHelf; //选中的关键字
        });

        this.checkedRule = arrAll.concat(this.checkedRule);
      }
      // });

      //   this.checkedRule = checked.halfCheckedNodes;
      // this.checkedNodes = checked.checkedNodes;

      // if (this.checkedRule.length > 0) {

      //   let arr: any = [];
      //   this.checkedRule.forEach((item: any, index: any) => {
      //     arr = [];
      //     item.children.forEach((c: any, y: any) => {
      //       this.checkedNodes.forEach((o: any, m: any) => {
      //         if (o.$treeNodeId == c.$treeNodeId) {
      //           arr.push(o);
      //           //
      //         }
      //       });
      //     });
      //     item.children = arr; //选中的关键字
      //   });

      //   // if (this.checkedNodes)
      // } else {
      //   let res: any = [];
      //   this.checkedNodes.forEach((iten: any, index: any) => {
      //     if (index % 2 === 0) {
      //       res.push(iten);
      //     }
      //   });
      //   this.checkedRule = res;
      // }
    }
  }

  private saveAudioMarkText(val: any) {
    if (val) {
      let obj: any = {
        id: (this.$refs.Copywriting as any).selectTextId,
        ContentMark: (this.$refs.Copywriting as any).selectText,
        ContentModify: (this.$refs.Copywriting as any).correctcopywritingB,
        AudioId: "",
      };
      this.AudioMarkTextList.push(obj);
    }
  }
  //获取错误原因

  //废弃规则弹窗
  private goRecodingDetailPage(row: any, index: any) {
    this.showDialogType = 1;
    this.sureAbandonindex = index;
    // this.caseresultListData.forEach((item: any, indexe: any) => {
    //   if (indexe == index) {
    //     item.status = 2;
    //     item.changeFlag = true;
    //   }
    // });
  }
  //废弃规则
  private sureAbandon() {
    if (this.selecterr) {
      this.caseresultListData.forEach((item: any, indexe: any) => {
        if (indexe == this.sureAbandonindex) {
          item.status = 2;
          item.changeFlag = true;
          item.discardreason = this.selecterr;
          item.remark = this.textareaText;
        }
      });
      this.selecterr = null;
      this.textareaText = null;
      this.showDialogType = 0;
    } else {
      this.$message.error("pls check the value");
    }
  }
  //鼠标移动事件
  private getContenttext(event: any, index: any) {
    if (!this.isfix && this.isshowButton) {
      const e = event || window.event;
      const selectTextId: any = (document as any).getSelection().anchorNode
        .parentNode.id;
      this.selectTextId = selectTextId;
      const selectText: any = (document as any).getSelection().toString();
      this.selectText = selectText;
      //  if (selectTextId1=='') {
      //    this.offsetX.forEach((item:any,index:any) => {
      //      this.$set(this.offsetX,index,false)
      //    });
      //  }
      const element = (document as any).getElementsByClassName("postion");
      element[index].style.left = e.offsetX + "px";
      element[index].style.top = e.offsetY + 20 + "px";
      if (e.offsetX && e.offsetY) {
        this.$set(this.offsetX, index, true);

        e.stopPropagation();
      }
      return selectTextId;
    }
  }
  //s失焦
  private blur() {
    const selectTextId1: any = (document as any).getSelection().toString();
    if (selectTextId1 == "") {
      this.offsetX.forEach((item: any, index: any) => {
        this.$set(this.offsetX, index, false);
      });
    }
  }
  //修正
  private fixsubmitPoint() {
    this.isfix = false;
  }
  //fixsubmitPoint无须修正
  private notfixsubmitPoint() {
    this.SaveVoipQICaseReqRequest(4);
  }
  //获取质检工单详情
  private getVoipQICaseReq(id: any) {
    let request: any = new GetVoipQICaseReq();
    request.setCommonin(setCommon());
    request.setTicketid(Number(id));
    request.setItemid(105); //Number(row.itemid)
    collectionServiceClient.getVoipQualityInspectionCase(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          let _fuc = this.getVoipQualityInspectionCaseFuc;
          handleResponse(data, _fuc);
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          } else {
            this.$message.error(err.errmsg || err.message);
          }
        }
      }
    );
  }
  private getVoipQualityInspectionCaseFuc(data: any) {
    this.recotData = data;
    data.calltextList.forEach((item: any) => {
      item.offsetX = false;
    });
    this.calltextList = data.calltextList;
    this.calldirection = data.dialinfo.calldirection;
    this.Aging = data.caseresult.caselevel;
    this.caseid = data.dialinfo.orderid;
    this.urgeusername = data.caseresult.urgeusername;
    this.caseresult = data.caseresult;
    this.voipqiresultmapMap = data.discardreasonList;
    let arr: any = [];
    data.caseresult.airesultList.forEach((item: any, index: any) => {
      arr = [];
      item.sentence = "part" + item.sentence;
      item.score = item.score > 0 ? "+" + item.score : item.score;
      item.qualitykind = "AI";
      item.qualitykindnum = 1;

      item.simlistList.forEach((a: any) => {
        arr.push(a.simtext);
      });
      item.simlistListNew = arr;
    });
    data.caseresult.humanresultList.forEach((item: any, index: any) => {
      arr = [];
      item.sentence = "part" + item.sentence;
      item.score = item.score > 0 ? "+" + item.score : item.score;
      item.qualitykind = this.$tc("dashbordDy.artificial");
      item.qualitykindnum = 2;
      item.simlistList.forEach((a: any) => {
        arr.push(a.simtext);
      });
      item.simlistListNew = arr;
      // item.qualitykind == 1 ? "AI" : this.$tc("dashbordDy.artificial");
    });
    this.pagerCount = data.caseresult.airesultList.length;
    // finalscore
    this.finalscoreList = data.caseresult.finalscore;
    // this.caseresultListData.push(
    //   data.caseresult.airesultList,
    //   data.caseresult.humanresultList
    // );
    this.caseresultListData = data.caseresult.airesultList.concat(
      data.caseresult.humanresultList
    );
    if (data.caseresult.status == 4) {
      this.isshowButton = false;
    } else {
      this.isshowButton = true;
    }
    this.status =
      data.caseresult.status == 4
        ? this.$tc("performance.completed")
        : data.caseresult.status == 6
        ? this.$tc("ticketFhb.partialCompleted")
        : this.$tc("dashbordDy.created");
    this.hangupcause = data.dialinfo.hangupcause;
    this.aiscore = data.caseresult.aiscore;
    this.humanscore = data.caseresult.humanscore;
    this.MachineQuality =
      data.caseresult.aistatus == 2
        ? this.$tc("dashbordDy.Qualityinspected")
        : this.$tc("dashbordDy.Notinspected");
    this.starttimestamp = timeFormat(data.dialinfo.starttimestamp);
    // this.starttimestamp = data.dialinfo.billsec / 60;
    // if (this.status == "4" || this.status == "5") {
    //   this.disabled = true;
    //   this.recotdingForm.resultTxt = data.caseresult.comment;
    //   this.recotdingForm.name = String(data.caseresult.calltype);
    //   data.audiomarktextMap.forEach((item: any, index: number) => {
    //     item[1].listList.forEach((n: any, m: number) => {
    //       if (item[1].listList[0].label == 1) {
    //         if (n.contentmark == "1") {
    //           this.isCheckednormal = true;
    //         }
    //       } else {
    // this.dynamicTags[item[1].listList[0].label - 1][m] = n.contentmark;
    // }
    //   });
    // });
    // }
    // // this.audiorecordurl=data.dialinfo.audiorecordurl
    // this.audiorecordurl="data:" + data.media.mediaheader + ";base64," + data.media.mediabody;
    // // this.audiorecordurl=data.dialinfo.audiorecordname
  }
  private submitRecotding() {
    this.SaveVoipQICaseReqRequest(4);
  }
  private LaterconfirmRecotding() {
    let caseresultListDataLast: any = [];
    this.caseresultListData.forEach((item: any) => {
      if (item.changeFlag) {
        caseresultListDataLast.push(item);
      }
    });
    if (
      this.checkedRule.length == 0 &&
      this.AudioMarkTextList.length == 0 &&
      caseresultListDataLast.length == 0
    ) {
      this.$message("pls check value");
    } else {
      //点击玩一次部分完成后
      this.SaveVoipQICaseReqRequest(6);
    }
  }
  private SaveVoipQICaseReqRequest(num: number, row?: any) {
    let request: any = new SaveVoipQICaseReq();
    let objData: any = new VoipQICaseData();

    let arr: any = [];
    this.AudioMarkTextList.forEach((item: any, index: any) => {
      let audioMarkText: any = new AudioMarkText();
      audioMarkText.setContentmodify(item.ContentModify);
      audioMarkText.setLabel(); //Number(item.Label) + 1
      audioMarkText.setSpeechid(Number(item.id)); //SpeechId
      audioMarkText.setId();
      audioMarkText.setAudioid(this.callrecordid);
      audioMarkText.setContentmark(item.ContentMark);
      arr.push(audioMarkText);
    });
    objData.setMarktextList(arr);
    let arr2: any = [];
    // if (row) {
    this.humanqualityList = [];

    this.caseresultListData.forEach((item: any, index: any) => {
      //智能质检
      if (item.qualitykindnum == 1) {
        let qualityReport: any = new QualityReport();
        qualityReport.setId(item.id);
        qualityReport.setSentence(Number(item.sentence.slice(4)));
        qualityReport.setRuleid(item.ruleid);
        qualityReport.setRulename(item.rulename);
        qualityReport.setHitscriptidList(item.hitscriptidList); //话术点
        qualityReport.setHitwordList(item.hitwordList); //关键词
        qualityReport.setQualitykind(1); //AI
        qualityReport.setScore(item.score);
        qualityReport.setUsername(item.username);
        // if (item.id == row.id) {
        //   qualityReport.setStatus(2);
        // } else {
        qualityReport.setStatus(item.status);
        // }
        qualityReport.setDiscardreason(item.discardreason);
        qualityReport.setRemark(item.remark);
        qualityReport.setDesc(item.desc);
        let arrsimlistList: any = [];
        item.simlistList.forEach((e: any) => {
          let SimInforeq: any = new SimInfo();
          SimInforeq.setLabel(e.label);
          SimInforeq.setSimtext(e.simtext);
          SimInforeq.setConfidence(Number(e.confidence));
          arrsimlistList.push(SimInforeq);
        });
        qualityReport.setSimlistList(arrsimlistList);
        arr2.push(qualityReport);
      } else {
        this.humanqualityList.push(item);
      }
    });
    // }
    objData.setAiresultList(arr2);

    let children: any = [];
    let humanqualityListo: any = [];
    if (this.humanqualityList.length > 0) {
      this.humanqualityList.forEach((item: any) => {
        // item.qualitypointlistList.forEach((it: any, o: any) => {
        //
        // children.push({
        //   id: o,
        //   label: it.scriptpoint.data.scriptname,
        //   scriptnameid: it.scriptpoint.data.id,
        //   scripttextList: it.scriptpoint.data.scripttextList,
        // });
        // });
        humanqualityListo.push({
          id: item.ruleid,
          label: item.rulename,
          scorevalue: item.score > 0 ? "1" : "2",
          score: Math.abs(item.score),
          status: item.status,
          username: item.username,
          selectText: item.contentmark,
          selectTextId: item.id,
          hitwordList: item.hitwordList,
          discardreason: item.discardreason,
          remark: item.remark,
          // children,
        });
      });
    }

    let humanqualityList = this.checkedRule.concat(humanqualityListo); //合并列表里的人工质检list

    let arr1: any = [];

    humanqualityList.forEach((item: any, index: any) => {
      //人工质检
      this.calltextList.map((p: any) => {
        if (p.id == item.selectTextId) {
          item.sentence = p.sentence;
        }
      });
      // let str: any = [];
      let scripttextList: any = [];
      let str: any = "";
      if (item.children) {
        str = item.children.map((p: any) => {
          // return "" + p.scriptnameid;
          return "" + p.label;
        }); // 转换类型为string array
      }

      // item.children.forEach((o: any) => {
      //   // str.push(o.label);
      //   scripttextList = o.scripttextList;
      // });

      let qualityReport1: any = new QualityReport();
      qualityReport1.setId(Number(item.selectTextId));
      qualityReport1.setSentence(item.sentence);
      qualityReport1.setRuleid(item.id);
      qualityReport1.setRulename(item.label); //规则名称
      // qualityReport1.setHitscriptidList(str); //话术点
      qualityReport1.setHitwordList(str ? str : item.hitwordList); //关键词
      qualityReport1.setQualitykind(2); //人工
      qualityReport1.setScore(
        // item.score
        item.scorevalue === "1" ? item.score : "-" + item.score
      );
      qualityReport1.setStatus(item.status);
      qualityReport1.setDesc(item.desc);
      qualityReport1.setUsername(item.username);
      qualityReport1.setContentmark(item.selectText);
      qualityReport1.setDiscardreason(item.discardreason);
      qualityReport1.setRemark(item.remark);
      let arrsimlistList: any = [];
      if (item.children) {
        item.children.forEach((e: any) => {
          let SimInforeq: any = new SimInfo();
          SimInforeq.setLabel(e.scriptnameid);
          SimInforeq.setSimtext(item.selectText);
          SimInforeq.setConfidence(Number(100));
          arrsimlistList.push(SimInforeq);
        });
      } else if (item.hitwordList) {
        item.hitwordList.forEach((p: any) => {
          let SimInforeq: any = new SimInfo();
          SimInforeq.setLabel(p);
          SimInforeq.setSimtext(item.selectText);
          SimInforeq.setConfidence(Number(100));
          arrsimlistList.push(SimInforeq);
        });
      }

      qualityReport1.setSimlistList(arrsimlistList);
      arr1.push(qualityReport1);
    });
    objData.setHumanresultList(arr1);
    objData.setItemid(105);
    objData.setTicketid(this.caseresult.ticketid);
    objData.setCalltype(this.recotdingForm.name);
    objData.setResult("0");
    objData.setComment(this.recotdingForm.resultTxt);
    objData.setStatus(num);
    objData.setCaselevel(this.caseresult.caselevel);
    objData.setAiscore();
    objData.setHumanscore();
    objData.setFinalscore();
    objData.setAistatus();
    // objData.addMarktext(audioMarkTextList)
    request.setCommonin(setCommon());
    request.setData(objData);
    collectionServiceClient.saveVoipQualityInspectionCase(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout.code == 0) {
            this.$message.success("success");
            if (num == 6) {
              // this.bufen=true
              this.checkedRule = [];
              this.AudioMarkTextList = [];
              this.caseresultListData = [];
            }
            // this.$route.query.status = this.$tc("performance.completed");
            // this.status = this.$tc("performance.completed");
            this.disableQ = true;
            this.isshowButton = false;
            this.getVoipQICaseReq(this.$route.query.id);
            if (row) {
            }
          } else {
            this.$message.error(
              data.commonout.errmsg || data.commonout.message
            );
          }
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          } else {
            this.$message.error(err.errmsg || err.message);
          }
        }
      }
    );
  }
  private audioPlay1(val: any) {
    this.audioPlay(val.val, val.index, val.timeend);
  }
  // lee 录音文件播放
  private async audioPlay(val: any, index: number, timeend: number) {
    var audio: any = document.querySelector("audio");
    audio.duration;
    audio.currentTime = val;
    var audioFunc = function() {
      audio.play();
      if (audio.currentTime >= timeend) {
        audio.pause();
        audio.removeEventListener("timeupdate", audioFunc);
      }
    };
    audio.addEventListener("timeupdate", audioFunc);
  }
  // lee 获取录音文件
  private async getAudio(callrecordid: any) {
    // row.videoLoading = true;
    this.audioPlayLoading = true;
    this.disabledSubmit = true;
    const { getDialListMediaV2 }: any = await import("@/request/getDialList");
    let _arg = {
      VOIPRecordID: callrecordid,
    };
    let response = await getDialListMediaV2(_arg);
    if (response && response.right) {
      // row.videoLoading = false;
      // row.videoShow = true;
      this.audioPlayLoading = false;
      this.disabledSubmit = false;
      this.audiorecordurl =
        "data:" + response.mediaheader + ";base64," + response.mediabody;
      //   this.timelong=timelong
      //   this.audio=this.$refs.audioExl
      //   this.audio.currentTime=val
      //   this.audio.play()
      //   this.sliderValue[index]=100
    }
  }
  private hideMaskVue() {
    this.$emit(
      "hideManualUpgradeTicketDialogue",
      false
      // {
      //     hidden: true,
      //     val: null
      // }
    );
  }
}
